<template>
  <div class="container">
    <div class="left" @click="showMenu">
      <userMenu :headImg="require('../../public/images/user.jpg')" :currentType="2" :showFlag="menuFlag"></userMenu>
    </div>
    <div class="right">
      <h5>我的报名</h5>
      <section class="mycourse">
        <p class="noList" v-if="list.length==0">
          当前未报名任何课程
        </p>
        <div class="table" v-else>
          <div class="row thead">
            <div class="item">培训时间</div>
            <div class="item">课程内容</div>
            <div class="item">授课老师</div>
            <div class="item">教室</div>
            <div class="item">报名人</div>
            <div class="item">状态</div>
            <div class="item">操作</div>
          </div>
          <div class="row" v-for="item in list">
            <div class="item">{{item.start_time.substr(0,10)}}</div>
            <div class="item">{{item.content}}</div>
            <div class="item">{{item.teacher}}</div>
            <div class="item">{{item.room}} </div>
            <div class="item">{{item.bm_user_name}} </div>
            <div class="item">{{item.status==0?'未开始':item.status==1?'进行中':'已结束'}}</div>
            <div class="item">
              <div :class="item.status==-1?'btn btn-default':'btn btn-primary'" @click="cancel(item.id,item.status)">取消报名</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import userMenu from '../components/user.vue'
export default {
  inject: ['ajax'],
  props: {

  },
  data() {
    return {
      list: [],
      menuFlag: false
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {
    this.ajax('/api/course/signList', 'get', '', res => {
      this.list = res.data.data
    })
  },
  watch: {

  },
  methods: {
    showMenu() {
      this.menuFlag = !this.menuFlag
    },
    cancel(id, status) {
      if (status != -1) {
        this.ajax('/api/course/cancelSign', 'post', this.$qs.stringify({ id: id }), res => {
          this.$toast('取消报名')
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        })
      }
    }
  },
  components: {
    userMenu
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
}

.left {
  width: 200px;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
}

.row > .item {
  flex: 1;
  text-align: center;
}

.row > .item > span {
  color: #999;
}

.thead {
  background: #4ba6ff !important;
  color: #fff;
}

.row:nth-child(2n + 1) {
  background: #f5f5f5;
}
.mycourse {
  padding: 15px 0;
}
.noList {
  font-size: 0.9em !important;
  color: #999 !important;
  text-align: center;
  font-weight: normal;
}
@media only screen and (max-width: 750px) {
  .right > h5 {
    font-size: 1em;
    padding-bottom: 0.1rem;
  }
  .myorder > p {
    font-size: 0.14rem;
  }
  .right {
    padding: 0.1rem;
  }
  .item {
    font-size: 0.12rem;
  }
}
</style>